var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-break-out"},[_c('h1',{staticClass:"text-center text-light p-4 text-uppercase font-weight-bold"},[_vm._v("\n    "+_vm._s(_vm.heading)+"\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }